<section class="main-banner credito">
    <div class="wrapper">
        <div class="banner" *ngIf="banner">
            <div class="two-col">
                <div class="info">
                    <p class="flex"><mat-icon>arrow_forward</mat-icon>{{banner.tipo}}</p>
                    <h2>{{banner.texto_alternativo}}</h2>
                    <p [innerHTML]="banner.link"></p>
                    <button (click)="scrollToForm()">Solicitar asesoría<mat-icon>arrow_forward</mat-icon></button>
                </div>
                <img *ngIf="banner && banner.image" [src]="banner.image.src" [alt]="banner.image.alternativeText">
            </div>
        </div>
    </div>
</section>

<section class="credito-info">
    <div class="wrapper">
        <div class="info">
            <h1><b>Crédito automotriz</b> con BitCar</h1>
            <p>Te brindamos seguridad y confianza en tu financiamiento. En BitCar, <b>somos una empresa hermana</b> de <img src="./assets/img/landing-ex/tip.png" alt="banner"> y por ello, contamos con el respaldo para ofrecerte una <b>solución personalizada</b>.</p>
        </div>
    </div>
</section>

<section class="why">
    <div class="two-col">
        <div class="img">
            <img *ngIf="bannerBeneficios" [src]="bannerBeneficios.src" [alt]="bannerBeneficios.alternativeText">
        </div>
        <div class="info">
            <h2><b>Beneficios</b> de tu vehículo a Crédito con BitCar</h2>
            <p>Elige un esquema moderno y flexible para manejar tu auto nuevo con total seguridad y acompañado de servicios:</p>
            <ul>
                <li>
                    <div class="icon" [ngClass]="{'active' : feature === 0}">
                        <mat-icon>star</mat-icon>
                    </div>
                    <p><b>Protección total durante todo el plazo:</b> incluye seguro de vida, seguro de vehículo, vehículo sustituto y más.</p>
                </li>
                <li>
                    <div class="icon" [ngClass]="{'active' : feature === 1}">
                        <mat-icon>paid</mat-icon>
                    </div>
                    <p><b>Desde el 5% de enganche</b> cuida tu liquidez, sin descapitalizarte.</p>
                </li>
                <li>
                    <div class="icon" [ngClass]="{'active' : feature === 2}">
                        <mat-icon>payments</mat-icon>
                    </div>
                    <p><b>Pagos flexibles:</b> elige entre pagos adicionales, anuales o al final del plazo, con mensualidades ajustadas a tu presupuesto.</p>
                </li>
                <li>
                    <div class="icon" [ngClass]="{'active' : feature === 3}">
                        <mat-icon>directions_car</mat-icon>
                    </div>
                    <p><b>Amplio catálogo de vehículos nuevos:</b> el más grande de México, con opciones que se adaptan a ti.</p>
                </li>
            </ul>
            <button (click)="scrollToForm()">Solicitar asesoría <mat-icon>arrow_forward</mat-icon></button>
        </div>
    </div>
</section>

<section class="options">
    <div class="center-title">
        <h2>Tu vehículo, <b>tus opciones de financiamiento</b> A Tu Manera</h2>
    </div>

    <div class="three-col">
        <div class="card">
            <div class="top">
                <mat-icon>check_circle</mat-icon>
            </div>
            <div class="info">
                <div class="center">
                    <h3><b>Crédito tradicional</b></h3>
                </div>
                <ul>
                    <li>
                        <mat-icon>check</mat-icon>
                        <p>Enganche desde el 5% con mensualidad idéntica cada año</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="card">
            <div class="top">
                <mat-icon>check_circle</mat-icon>
            </div>
            <div class="info">
                <div class="center">
                    <h3><b>Crédito anualidades</b></h3>
                </div>
                <ul>
                    <li>
                        <mat-icon>check</mat-icon>
                        <p>Pagos programados en algún mes del año que ayudan a disminuir la mensualidad.</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="card">
            <div class="top">
                <mat-icon>check_circle</mat-icon>
            </div>
            <div class="info">
                <div class="center">
                    <h3><b>Crédito ballon</b></h3>
                </div>
                <ul>
                    <li>
                        <mat-icon>check</mat-icon>
                        <p>Programamos un pago al final del plazo para reducir tu enganche y mensualidades.</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="destacados">
    <div class="wrapper">
        <div class="two-col title">
            <h2>Vehiculos más vendidos por <b>Crédito en Bitcar</b></h2>
            <div class="info-border">
                <p>En BitCar buscamos darte un financiamiento A Tu Manera con enganche desde 5%, servicios integrales y un auto que se ajuste a tu presupuesto, tu estilo de vida y tus gustos.</p>
                <p>Conoce los <b>autos más comunes en Crédito</b>, si tienes dudas de cual es el mejor modelo para ti, nosotros te asesoramos.</p>
            </div>
        </div>
        <div class="three-col">
            <div class="destacado" *ngIf="destacado1">
                <img [src]="destacado1.image.src" [alt]="destacado1.image.alternativeText">
                <p>{{destacado1.link}}</p>
            </div>
            <div class="destacado" *ngIf="destacado2">
                <img [src]="destacado2.image.src" [alt]="destacado2.image.alternativeText">
                <p>{{destacado2.link}}</p>
            </div>
            <div class="destacado" *ngIf="destacado3">
                <img [src]="destacado3.image.src" [alt]="destacado3.image.alternativeText">
                <p>{{destacado3.link}}</p>
            </div>
        </div>
        <div class="action">
            <button (click)="scrollToForm()">Contactanos <mat-icon>arrow_forward</mat-icon></button>
        </div>
    </div>
</section>

<section class="mejor-opcion">
    <div class="wrapper">
        <div class="two-col title">
            <h2>Tu proceso es <b>más fácil</b> de lo que crees</h2>
            <div class="info-border">
                <p>Antes de aprobar tu Crédito automotriz, revisamos tus documentos para asegurarnos de que el plan se adapte a tus posibilidades y no comprometa tu estabilidad financiera. Estos son los requisitos básicos para personas asalariadas:</p>
            </div>
        </div>
        <div class="two-col">
            <div class="img">
                <img *ngIf="bannerRequisitos" [src]="bannerRequisitos.src" [alt]="bannerRequisitos.alternativeText">
            </div>
            <div class="info">
                <div class="two-col">
                    <div class="mini-card">
                        <h3>01</h3>
                        <p>Recibos de nómina y/o estados de cuenta</p>
                    </div>
                    <div class="mini-card">
                        <h3>02</h3>
                        <p>Comprobante de domicilio</p>
                    </div>
                    <div class="mini-card">
                        <h3>03</h3>
                        <p>Constancia de situación fiscal</p>
                    </div>
                    <div class="mini-card">
                        <h3>04</h3>
                        <p>Identificación oficial</p>
                    </div>
                </div>
                <div class="mini-card tip">
                    <div class="icon">
                        <mat-icon>info</mat-icon>
                    </div>
                    <p>Además, vamos a requerir una precalificación digital. con datos adicionales sobre tus ingresos, historial crediticio y datos demográficos.</p>
                </div>
            </div>
        </div>        
    </div>

    <div class="brands" #asesoria>
        <div class="brands-wrapper">
            <div class="carrousel">
                <span>Honda</span>
                <span>Toyota</span>
                <span>Hyundai</span>
                <span>KIA</span>
                <span>Chevrolet</span>
                <span>Ford</span>
                <span>Renault</span>
                <span>BMW</span>
                <span>Ford</span>
                <span>Jeep</span>
                <span>Mazda</span>
                <span>Mercedes</span>
                <span>Mini</span>
                <span>Nissan</span>
                <span>Seat</span>
                <span>Suzuki</span>
            </div>
        </div>
    </div>
</section>

<section class="asesoria"> 
    <app-asesoria-form type="Landing Page Crédito"></app-asesoria-form>
</section>
